import {connect} from "react-redux";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormInput, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import StoreListWhere from "../../where/StoreListWhere";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as formatter from "../../../../config/formatter";
import * as o2Api from "../../../../api/api";
import "src/scss/grid-styles.scss";
import {Loading} from "../../../../components/common";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";

const BillSaleDetailReport = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);

	const [pos, setPos] = useState([{deviceId: "전체"}]);
	const [reportData, setReportData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({
		deviceId: "전체",
		saleDt: dayjs(),
	    itemCd: "",
		itemNm: "",
		barcode: ""
	});

	const defaultColDef = {
		flex: 1,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [statsColumnDefs] = useState([
		{headerName: "포스\n번호", minWidth: 50, field: "posCd", cellClass: "static-cell"},
		{headerName: "영수증번호", minWidth: 80, field: "billNo", cellClass: "static-cell"},
		{headerName: "E-휴게소\n영수증번호", minWidth: 80, field: "erestBillNo", cellClass: "static-cell"},
		{field: "tradeTypeNm", headerName: "구분", minWidth: 60, cellClass: "static-cell"},
		{
			field: "saleTime",
			headerName: "결제시각",
			valueFormatter: (e) => formatter.timeFormatter(e, "YYYYMMDDHHmmss", "HH:mm:ss"),
			minWidth: 80,
			cellClass: "static-cell"
		},
		{headerName: "상품코드", minWidth: 150, field: "restProductCd", cellClass: "static-cell"},
		{headerName: "바코드", minWidth: 150, field: "barcode", cellClass: "static-cell"},
		{headerName: "상품명", minWidth: 200, field: "productNm"},
		{
			field: "saleQty",
			headerName: "수량",
			minWidth: 60,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "saleAmt",
			headerName: "총매출액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "dcAmt",
			headerName: "할인액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "payAmt",
			headerName: "실매출액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "netAmt",
			headerName: "가액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "vatAmt",
			headerName: "부가세",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "bagPrice",
			headerName: "봉투",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		}
	]);

	const [totalRowData] = useState([
		{posCd: "합계", saleTime: null, saleQty: 0, saleAmt: 0, dcAmt: 0, payAmt: 0, netAmt: 0, vatAmt: 0, bagPrice: 0}
	])

	const sum = (values, col) => {
		let sum = 0;
		values.forEach((value) => {
			sum += value[col]
		})
		return sum;
	}

	const createFooterData = (data) => {
		const api = gridRef.current.api;
		const result = [];
		// {posCd: "합계", saleTime: null, saleQty: 0, saleAmt: 0, dcAmt: 0, payAmt: 0, netAmt: 0, vatAmt: 0, bagPrice: 0}
		result.push({
			posCd: "합계",
			saleTime: null,
			saleQty: sum(data, 'saleQty'),
			saleAmt: sum(data, 'saleAmt'),
			dcAmt: sum(data, 'dcAmt'),
			payAmt: sum(data, 'payAmt'),
			netAmt: sum(data, 'netAmt'),
			vatAmt: sum(data, 'vatAmt'),
			bagPrice: sum(data, 'bagPrice'),

		});
		api.setPinnedBottomRowData(result);
	};

	useEffect(() => {
		if (props.selected.storeCd.length > 0) {
			getStoreDevice();
		}
	}, [props.selected.storeCd]);

	const getStoreDevice = () => {
		const {cmpCd, brandCd, storeCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			useYn: "Y"
		};
		setLoading(true);
		o2Api.getStoreDevice(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				// 성공
				setPos([{deviceId: "전체"}]);
				setPos((state) => state.concat(responseBody));

				setLoading(false);
			}
		});
	};

	const search = () => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd} = props.selected;
		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
			//productNm: searchForm.productNm,
            restProductCd: searchForm.itemCd,
            productNm: searchForm.itemNm,
            barcode: searchForm.barcode,
			fromSaleDt: searchForm.saleDt.format("YYYYMMDD"),
			toSaleDt: searchForm.saleDt.format("YYYYMMDD"),
		};

		setLoading(true);
		o2Api.getBillSaleDetail(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				console.log("stat : ", responseBody);

				setLoading(false);
				setReportData(responseBody);

				createFooterData(responseBody);
			}
		});
	};

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				brandCd: code
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				storeCd: code
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cornerCd: code
			}));
		}
	};

	return (
		<>
			<div style={containerStyle}>
				{loading ? <Loading/> : null}
				{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
				<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
					<h5>영수증별매출상세현황</h5>
					<CButton size={"sm"} color="dark" onClick={search}>조회</CButton>
				</div>
				<CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
					<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
					<CCol xs={12}>
						<CInputGroup size={"sm"}>
							<CInputGroupText style={{width: 80}}>조회일자</CInputGroupText>
							<CInputGroupText style={{background: "white", height: 35}}>
								<DatePicker bordered={false}
											separator={"~"}
											placeholder={""}
											locale={locale}
											value={searchForm.saleDt}
											onChange={(dayjs, dateString) => {
												setSearchForm((state) => ({
													...state, saleDt: dayjs
												}));
											}}/>
							</CInputGroupText>
						</CInputGroup>
					</CCol>
					<CCol xs={12}>
						<CInputGroup size={"sm"}>
							<CInputGroupText style={{width: 80}}>포스번호</CInputGroupText>
							<CFormSelect value={searchForm.deviceId}
										 onChange={(e) => {
											 setSearchForm((state) => ({
												 ...state,
												 deviceId: e.target.value
											 }));
										 }}
							>
								{pos.map((p, index) => {
									return (
										<option key={index} value={p.deviceId}>{p.deviceId}</option>
									);
								})}
							</CFormSelect>
						</CInputGroup>
					</CCol>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 80}}>상품코드</CInputGroupText>
                            <CFormInput id="itemCd"
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                itemCd: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
                            <CFormInput value={searchForm.itemNm}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                itemNm: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 80}}>바코드</CInputGroupText>
                            <CFormInput value={searchForm.barcode}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                barcode: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>

				</CForm>

				<div style={{height: 10}}/>
				<div>
					<div className="ag-theme-alpine" style={{width: "100%", height: 550, marginTop: 10}}>
						<AgGridReact
							ref={gridRef}
							rowSelection={"single"}
							headerHeight={30}
							rowHeight={30}
							rowData={reportData}
							animateRows={true}
							pinnedBottomRowData={totalRowData}
							defaultColDef={defaultColDef}
							columnDefs={statsColumnDefs}>
						</AgGridReact>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(BillSaleDetailReport);
